import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { industryTransitionKeys } from "../../utils/i18n";

import { ReportCrmNoticeBox } from "./styles";

type ImpactReportCrmNoticeProps = {
    readonly crmJobsCount: number;
};

/**
 * The report's CRM callout: informational, so it is a `role="note"` rather than a live region — it is
 * present from first paint, not an update, and a second `role="status"` would race the phase announcer.
 */
export const ImpactReportCrmNotice = ({ crmJobsCount }: ImpactReportCrmNoticeProps) => {
    const { translate } = useTranslate();

    return (
        <ReportCrmNoticeBox
            role="note"
            data-automation="industry-transition-impact-report-crm-notice"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
            >
                {translate(industryTransitionKeys.reportCrmNotice, { count: crmJobsCount })}
            </Text>
        </ReportCrmNoticeBox>
    );
};
